import { Routes, Route } from 'react-router-dom'
import { PageViewTracker } from '@/components/PageViewTracker'
import { AuthProvider } from '@/contexts/AuthContext'
import { WorkspaceProvider } from '@/contexts/WorkspaceContext'
import { PlansProvider } from '@/contexts/PlansContext'
import { LogRocketIdentify } from '@/contexts/LogRocketIdentify'
import { ChatProvider } from '@/contexts/ChatContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { ToastProvider } from '@/contexts/ToastContext'
import { Toaster } from '@/components/ui/Toaster'

// Pages
import LandingPage from '@/pages/LandingPage'
import LoginPage from '@/pages/LoginPage'
import AuthCallbackPage from '@/pages/AuthCallbackPage'
import RegisterPage from '@/pages/RegisterPage'
import DashboardPage from '@/pages/DashboardPage'
import ChatPage from '@/pages/ChatPage'
import DocsDetailPage from '@/pages/DocsDetailPage'
import CreateWorkspacePage from '@/pages/CreateWorkspacePage'
import DocsPage from '@/pages/DocsPage'
import WorkflowsPage from '@/pages/WorkflowsPage'
import SkillsPage from '@/pages/SkillsPage'

function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      storageKey="paladino-theme"
      enableSystem
      disableTransitionOnChange
    >
      <AuthProvider>
        <ToastProvider>
          <WorkspaceProvider>
            <PlansProvider>
              <LogRocketIdentify />
              <PageViewTracker />
              <ChatProvider>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/callback" element={<AuthCallbackPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/dashboard/chat/:chatId" element={<ChatPage />} />
                <Route path="/dashboard/chat/:projectId/:chatId" element={<ChatPage />} />
                <Route path="/workspaces/create" element={<CreateWorkspacePage />} />
                <Route path="/dashboard/workflows" element={<WorkflowsPage />} />
                <Route path="/dashboard/skills" element={<SkillsPage />} />
                <Route path="/docs" element={<DocsPage />} />
                <Route path="/docs/:docsId" element={<DocsDetailPage />} />
              </Routes>
              <Toaster />
              </ChatProvider>
            </PlansProvider>
          </WorkspaceProvider>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
